// extracted by mini-css-extract-plugin
export default {"btn":"GerarNfe_btn__2AWSL"};